/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Auto_Rate_TitleInputs */



/**
* | output |
* | --- |
* | "Auto-set Speed to match event duration, then render" |
*
* @param {Event_Ad_Auto_Rate_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_auto_rate_title = /** @type {((inputs?: Event_Ad_Auto_Rate_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Auto_Rate_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Régler automatiquement la vitesse en fonction de la durée de l'événement, puis générer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tempo automatisch an die Ereignisdauer anpassen, dann rendern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imposta automaticamente la velocità in base alla durata dell'evento, quindi esegui il rendering.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скорость воспроизведения автоматически устанавливается в соответствии с продолжительностью события, затем выполняется рендеринг.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajusta automáticamente la velocidad para que coincida con la duración del evento y luego renderiza.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动设置播放速度以匹配事件时长，然后渲染")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの長さに合わせて再生速度を自動設定し、レンダリングします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट की अवधि के अनुसार गति स्वतः निर्धारित करें, फिर रेंडर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Defina automaticamente a velocidade para corresponder à duração do evento e, em seguida, renderize.")
	return /** @type {LocalizedString} */ ("Auto-set Speed to match event duration, then render")
});